import { AvatarIconOrName, AvatarNew } from '@platform/components';
import { LogoTopBkg } from './LogoTopBkg';

/** A colorful top panel for directory pages with random background images and a centered avatar */
export const LogoTopPanel = ({
  avatarUrl,
  avatarFallback,
  paddedAvatar,
  children,
}: {
  avatarFallback: AvatarIconOrName;
  avatarUrl?: string;
  isAvatar?: boolean;
  paddedAvatar?: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <>
      <div className='relative min-h-24 h-24 sm:min-h-60 sm:h-60'>
        <LogoTopBkg />
        <div className='absolute px-4 sm:px-0 left-0 right-0 -bottom-25 sm:-bottom-10 mx-auto w-fit'>
          <div className='w-24 h-24 sm:w-40 sm:h-40'>
            <AvatarNew url={avatarUrl} {...avatarFallback} withPadding={paddedAvatar} />
          </div>
        </div>
      </div>
      <div className='text-center px-4 pb-0'>
        <div className='pt-30 sm:pt-14 max-w-7xl text-balance mx-auto'>{children}</div>
      </div>
    </>
  );
};
